var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenericoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M18.8125 0C22.1262 0 24.8125 2.68629 24.8125 6V18C24.8125 21.3137 22.1262 24 18.8125 24H6.8125C3.49879 24 0.8125 21.3137 0.8125 18V6C0.8125 2.68629 3.49879 0 6.8125 0H18.8125Z",
    fill: "#354887"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_898_52057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.479 12.999C19.479 13.8746 19.3066 14.7415 18.9715 15.5504C18.6365 16.3593 18.1454 17.0942 17.5263 17.7133C16.9072 18.3324 16.1722 18.8235 15.3634 19.1585C14.5545 19.4936 13.6875 19.666 12.812 19.666C11.9365 19.666 11.0695 19.4936 10.2607 19.1585C9.45179 18.8235 8.71683 18.3324 8.09774 17.7133C7.47865 17.0942 6.98756 16.3593 6.65251 15.5504C6.31747 14.7415 6.14502 13.8746 6.14502 12.999C6.14502 11.2308 6.84743 9.53506 8.09774 8.28475C9.34804 7.03445 11.0438 6.33203 12.812 6.33203C14.5802 6.33203 16.276 7.03445 17.5263 8.28475C18.7766 9.53506 19.479 11.2308 19.479 12.999Z",
    stroke: "#354887",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4789 12.9987C15.4789 13.874 15.4095 14.7414 15.2755 15.55C15.1422 16.3587 14.9455 17.0934 14.6975 17.7127C14.4502 18.332 14.1562 18.8227 13.8329 19.158C13.5089 19.4927 13.1622 19.6654 12.8122 19.6654C12.4622 19.6654 12.1155 19.4927 11.7922 19.158C11.4682 18.8227 11.1742 18.3314 10.9269 17.7127C10.6789 17.0934 10.4822 16.3594 10.3482 15.55C10.2115 14.7065 10.1437 13.8532 10.1455 12.9987C10.1455 12.1234 10.2142 11.256 10.3482 10.4474C10.4822 9.6387 10.6789 8.90403 10.9269 8.2847C11.1742 7.66536 11.4682 7.1747 11.7915 6.83936C12.1155 6.50536 12.4622 6.33203 12.8122 6.33203C13.1622 6.33203 13.5089 6.5047 13.8322 6.83936C14.1562 7.1747 14.4502 7.66603 14.6975 8.2847C14.9455 8.90403 15.1422 9.63803 15.2755 10.4474C15.4102 11.256 15.4789 12.1234 15.4789 12.9987Z",
    stroke: "#354887",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.14551 12.998H19.4788",
    stroke: "#354887",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_898_52057"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4.8125 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenericoIcon);
export default __webpack_public_path__ + "static/media/generico-icon.6dd357045916f8b5c01595ecd45f18f3.svg";
export { ForwardRef as ReactComponent };